#
#    @author Jaromír Navara [BG] <web@bagricek.cz>
#    26.8.2016 4:14
#
# A class-based template for jQuery plugins in Coffeescript
#
#     $('.target').hledani({ paramA: 'not-foo' });
#     $('.target').hledani('myMethod', 'Hello, world');
#
# Check out Alan Hogan's original jQuery plugin template:
# https://github.com/alanhogan/Coffeescript-jQuery-Plugin-Template
#
# REQUIRED: jQuery, palette.js, ionSound
#
(($, window) ->

  # Define the plugin class
  class Hledani
    $svgWrapper: null
    $hledaniImage: null
    $selectedColorEl: null
    itemCount: 0
    foundCount: 0
    animationDuration: 1200
    timeoutOfGameEnd: 2500

    victoryPage: false
    startTimerUrl: false
    stopTimerUrl: false

    points: 0, type: null
    #timers
    rtime: null
    timeout: false

    # Timer related variables
    timer: 0, timerInterval: null, timeSpent: 0, points: 0, matchedCount: 0, isFreezedTimer: false

    defaults:
      done: "#hledani_done"

    constructor: (el, options) ->
      @options = $.extend({}, @defaults, options)
      @$el = $(el)
      @type = options.type
      @$svgWrapper = @$el.find("svg")
      @$hledaniImage = @$el.find("img")
      imgSrc = @$hledaniImage.attr "src"
      image = new Image()
      image.onload = =>
        @init()
      image.src = imgSrc

    debug: (msg) =>
      if @options.debug
        console.log msg

    init: ->
      @$el.height "90%"
      @$el.css "position", "relative"
      @itemCount = @$svgWrapper.find(">g.item.correct").length
      $("#total_count").text @itemCount
      @_initSvg()
      $(window).resize @_onResize
      @_onResize()

      @_initPauseTimer()
      @_startTimer()

    _initSvg: ->
      @$svgWrapper.attr
        "id": "svg-root"
        "width": null
        "height": null
        "style": null

      @$svgWrapper.find(">g.item").click @_onItemClicked
      @$svgWrapper.show()

      @_resizeAll()

    hasClass: (element, cls) ->
      (' ' + element.getAttribute("class") + ' ').indexOf(' ' + cls + ' ') > -1

    _onItemClicked: (e) =>
      $item = $(e.currentTarget)
      if @hasClass $item[0],"correct"
        $item.unbind "click"
        if !ion.muted
          ion.sound.play("sound_match")
        @itemCount--
        $("#found_count").text(++@foundCount)
        @points += 5
        if @itemCount == 0
          @_finish()
      else
        @points--
        if !ion.muted
          ion.sound.play("sound_nomatch")
      @_animateClick($item, @hasClass($item[0],"correct"))
      if @type == "points" then @renderTimeSpent()

    _animateClick: ($item, correct = false, duration = 0, delay = 0) =>
      if duration == 0 then duration = @animationDuration
      $item.velocity
        scaleX: 1.5
        scaleY: 1.5
        opacity: 1
      ,
        duration: duration/2
        delay: delay
        queue: false
        complete: ->
          $item.velocity
            scaleX: 1
            scaleY: 1
            opacity: if correct then 1 else 0
          ,
            duration: duration/2
            delay: 0
            queue: false


    _onPathClicked: (e) =>
      if !ion.muted
        ion.sound.play("sound_click")
      if @$selectedColorEl != null
        color = @$selectedColorEl.data "hex"
        $(e.target).css "fill", color

    _fitSvg: ->

    _resizeAll: =>
      @$svgWrapper.width @$hledaniImage.width()
      @$svgWrapper.height @$hledaniImage.height()

      @$svgWrapper.css @$hledaniImage.offset()

    _onResize: (e = null)=>
      @_resizeAll()

    _startTimer: ->
      @debug("startTimer")
      @_clearTimer()
      $("#navigation_pause").slideDown()
      $.ajax
        url:   @options.startTimerUrl,
        type: "GET"
      if @type == "time"
        @timerInterval = setInterval =>
          if(!@isFreezedTimer)
            @timer++
            @timeSpent++
            @renderTimeSpent()
            #@debug("timer: #{@timer}")
        , 1000
      else
        @renderTimeSpent()

    _stopTimer: (redirect = null)->
      $.ajax
        url:   @options.stopTimerUrl,
        type: "GET",
        data: {points: @points}
        success: ->
          if(redirect != null)
            location.href = redirect

    _finish: ->
      @_clearTimer()
      @_stopTimer().then =>
        # wait for match animation to end and play
        setTimeout =>
          $("#overlay").removeClass("hidden");
          $(".action").hide();
          timePerAnimation = @timeoutOfGameEnd/@foundCount
          @finishAnimation timePerAnimation

          if !ion.muted
            ion.sound.stop("sound_music");
            ion.sound.play("sound_endgame")

          setTimeout =>
            location.href = @options.victoryPage
          , @timeoutOfGameEnd
        ,@animationDuration

    finishAnimation: (timePerAnimation)=>
      # 2500ms distributed among sequence animation of all found elements
      @$svgWrapper.find(">g.item.correct").each (index,val) =>
        @_animateClick $(val), true, timePerAnimation , timePerAnimation*index

    _clearTimer: ->
      clearInterval @timerInterval

    _initPauseTimer: ->
      @debug "initPauseTimer"
      $("#navigation_pause").click (e)=>
        @isFreezedTimer = !@isFreezedTimer
        $button = $(e.currentTarget)
        $button.toggleClass("navigation_play")
        $button.toggleClass("navigation_pause")
        $("#overlay").fadeToggle()

    renderTimeSpent: ->
      if @type == "time"
        #@debug "renderTimeSpent"
        minutes = Math.floor( @timeSpent/60 )
        seconds = Math.floor( @timeSpent - (minutes*60) )
        if(minutes < 10)
          minutes = "0" + minutes
        if(seconds < 10)
          seconds = "0" + seconds
        $("#points #value").text "#{minutes}:#{seconds}"
      else
        $("#points #value").text "#{@points}"




  # Define the plugin
  $.fn.extend hledani: (option, args...) ->
    @each ->
      $this = $(this)
      data = $this.data('hledani')

      if !data
        $this.data 'hledani', (data = new Hledani(this, option))
      if typeof option == 'string'
        data[option].apply(data, args)

) window.jQuery, window